import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {ComponentModule} from 'app/component/component.module';
import {PercentCircleComponent} from 'app/tool-layer/tools/percent-circle/percent-circle.component';

@NgModule({
    imports: [CommonModule, ComponentModule],
    declarations: [PercentCircleComponent],
    entryComponents: [PercentCircleComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(PercentCircleComponent),
            multi: true,
        },
    ],
})
export class PercentCircleModule {}
